import 'bootstrap'
import './plugins'
import './components'
// Stylesheets previously injected by Laravel via `@vite([...])` from
// resources/views/supplier/index.blade.php. Imported directly so the
// same bundle works for both the legacy blade-served path and the
// standalone Vite dev server (`npm run dev:supplier`).
import '../../sass/app.scss'
import '../../css/animate.css'
import '../css/style.css'
import 'vuejs-dialog/dist/vuejs-dialog.min.css'
import 'jquery-ui/dist/themes/base/jquery-ui.min.css'
import { Userpilot } from 'userpilot'
import vClickOutside from 'v-click-outside'
import VeeValidate from 'vee-validate'
import Vue from 'vue'
import VueDOMPurifyHTML from 'vue-dompurify-html'
import { VuejsDatatableFactory } from 'vuejs-datatable'
import VuejsDialog from 'vuejs-dialog'

import './api/axiosBase'

import App from './components/App'
import Vue18nCustomPlugin from './plugins/Vue18nCustomPlugin'
import router from './router'
import store from './store'

Vue.config.productionTip = false

Vue18nCustomPlugin.install()
let i18n = Vue18nCustomPlugin.getInstance()

// Initialize Userpilot
Userpilot.initialize('NX-482874b5')

/* eslint-disable no-new */
new Vue({
  i18n,
  store,
  router,
  ...App,
  watch: {
    $route: {
      handler() {
        return Userpilot.reload()
      },
      deep: true,
      immediate: true,
    },
  },
})

Vue.use(vClickOutside)
Vue.use(VuejsDialog)
Vue.use(VuejsDatatableFactory)
Vue.use(VueDOMPurifyHTML)
Vue.use(VeeValidate, {
  fieldsBagName: 'vvFields',
})
